import { useRef } from "react";
import { useTicker } from "./useRaf";

export default function useLoop(
  callback,
  {
    speed: _speed = 0.01,
    duration = 1,
    loopIncrementer = 1,
    initialProgress = 0,
    ...rafArgs
  } = {}
) {
  const loopAmount = useRef(0);
  const progress = useRef(initialProgress);

  const shouldUpdate = useRef(false);

  const speed = useRef(_speed);

  function setSpeed(s) {
    speed.current = s;
  }

  function resetProgress(useInitialProgress = true) {
    if (useInitialProgress) {
      progress.current = initialProgress;
    } else {
      progress.current = 0;
    }
  }

  const ticker = useTicker(({ delta }) => {
    progress.current += delta * speed.current;

    const currentLooped = loopAmount.current;
    if (progress.current > duration) loopAmount.current += loopIncrementer;
    shouldUpdate.current = currentLooped !== loopAmount.current;

    progress.current %= duration;

    callback({
      progress: progress.current / duration,
      shouldUpdate: shouldUpdate.current,
      loopedAmount: loopAmount.current,
      delta,
    });
  }, rafArgs);

  return { ...ticker, setSpeed, resetProgress };
}
